// Global action undo stack (Cmd/Ctrl+Z) for check-offs and deletes.
// Typing undo stays native: the shortcut is ignored while an input,
// textarea, or contenteditable has focus.
import { toast } from 'sonner';

const MAX_ENTRIES = 20;
const stack = [];

const isTypingTarget = (el) =>
  !!el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.isContentEditable);

async function runEntry(entry) {
  const i = stack.indexOf(entry);
  if (i === -1) return; // already undone via toast button
  stack.splice(i, 1);
  try {
    await entry.undoFn();
    toast.success(`Undone: ${entry.label}`);
  } catch (err) {
    console.error('Undo failed:', err);
    toast.error("Couldn't undo that action. Please try again.");
  }
}

// Register an undoable action. Optional toastMessage shows a confirmation
// toast with an inline "Undo" button (Gmail-style).
export function pushUndo(label, undoFn, { toastMessage } = {}) {
  const entry = { label, undoFn };
  stack.push(entry);
  if (stack.length > MAX_ENTRIES) stack.shift();
  if (toastMessage) {
    toast(toastMessage, {
      action: { label: 'Undo', onClick: () => runEntry(entry) },
    });
  }
}

if (typeof window !== 'undefined' && !window.__WOS_UNDO_INSTALLED__) {
  window.__WOS_UNDO_INSTALLED__ = true;
  window.addEventListener(
    'keydown',
    (e) => {
      if (!(e.metaKey || e.ctrlKey) || e.shiftKey || e.altKey) return;
      if ((e.key || '').toLowerCase() !== 'z') return;
      if (isTypingTarget(document.activeElement)) return; // native text undo
      if (stack.length === 0) return;
      e.preventDefault();
      runEntry(stack[stack.length - 1]);
    },
    true
  );
}
